// extracted by mini-css-extract-plugin
module.exports = {"basic-layout":"basic_basic-layout__U7H8Y","basicLayout":"basic_basic-layout__U7H8Y","loading":"basic_loading__180pV","spin":"basic_spin__13XYZ","turning":"basic_turning__3ovqX"};